"use strict";

/* global $ */
window.flafReloadSearch = false;

APP('search', function (self) {
    this.getParam = function (name) {
        if (name in this.params) {
            return this.params[name];
        }
        return null;
    };
    this.setParam = function (name, value) {
        this.params[name] = value;
        APP.events.fire('search-param-change');
    };
    this.setParams = function (params) {
        this.params = $.extend(this.params, params);
        APP.events.fire('search-param-change');
    };

    this.getCookie = function (name) {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    };

    this.refresh = function () {
        var req = APP.ajax.post(this.route.filter, this.params),
            filterUpdate = this.getParam('update_filters');
        if(filterUpdate === true) {
            $('.preloader').addClass('filter_preloader');
        }
        $('.preloader').css('visibility', 'visible');

        req.then(function (resp) {
            if(filterUpdate === false) {
                $.each(resp.replace, function (name, code) {
                    $('#xhr-' + name).html(code);
                });
                $.each(resp.append, function (name, code) {
                    $('#xhr-' + name).append(code);
                });

                history.replaceState({}, null, resp.url);

                //Update navigation
                $('#xhr-products').html(resp.replace.pager);
                $('.search_page__header span').html(resp.replace.total);

                //Scroll top
                if(resp.append.length === 0) {
                    $('html, body').stop().animate({
                        'scrollTop': $('.catalog_filter').offset().top
                    }, 300);
                }

                APP.edge_replace.on();
                window.flafReloadSearch = false;
            }

            //Filter
            if(resp.replace.filters) {
                $('#filter-list').html(resp.replace.filters);
                $(".mCustomScrollbar").mCustomScrollbar({
                    axis:"y"
                });
            }

            //
            if(resp.count_categories > 0) {
                $('.catalog_filter .filter').attr('data-category', 'true');
            }

            $(".preloader").css('visibility', 'hidden');
            $('.preloader').removeClass('filter_preloader');

        });
    };

    var refresh = APP.core.debounce(function () {
        APP.search.refresh();
    });
    APP.events.on('search-param-change', function () {
        refresh();
    });
});

APP('searchFilter', function (self) {
    this.setParams = function (params) {
        this.params = $.extend(this.params, params);
        APP.events.fire('searchFilter-param-change');
    };

    this.refresh = function () {
        var req = APP.ajax.post(this.route.filter, this.params);
        req.then(function (resp) {

            $('#filter-list').html(resp.replace.filters);
        });
    };

    var refresh = APP.core.debounce(function () {
        APP.searchFilter.refresh();
    });
    APP.events.on('searchFilter-param-change', function () {
        refresh();
    });
});

$(function () {
    var $container = $('.wrap_page.search_page'),
        $filters_search = $('#xhr-filter-search'),
        $category = $('.result_category'),
        categoryID = 0;

    if (!$container.length) {
        return;
    }

    //категория
    $category.on('click', 'h3', function () {
        var f = $(this).attr('data-slug');
        if (!f) {
            return;
        }

        categoryID = $(this).attr('data-id');

        var params = {
            'q': gup('q'),
            'categories': [categoryID],
            'prices': [],
            'price': '',
            'update_filters': false,
            'page': 1,
            'start': 1
        };

        APP.search.setParams(params);
    });

    function gup( name, url ) {
        if (!url) url = location.href;
        name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
        var regexS = "[\\?&]"+name+"=([^&#]*)";
        var regex = new RegExp( regexS );
        var results = regex.exec( url );
        return results == null ? null : results[1];
    }


    // сортировка
    $container.on('click', '.sort .select_menu li', function() {
        var f = $(this).attr('data-f');
        if (!f) {
            return;
        }

        var params = APP.fon.decode(f);
        params['update_filters'] = false;
        params['page'] = 1;
        params['start'] = 1;
        APP.search.setParams(params);
    });


    // пейджер
    $container.on('click', '.pagination li[data-p]:not(.active)', function(e) {
        e.preventDefault();

        var page = $(this).attr('data-p');
        APP.search.setParams({
            update_filters: false,
            start: page,
            page: page
        });
    });

    // показать еще
    $container.on('click', '#load-more', function(e) {
        e.preventDefault();

        var page = parseInt(APP.search.getParam('page'));
        APP.search.setParams({
            update_filters: false,
            page: page + 1
        });
    });

    //Обновляем только фильтры
    $filters_search.on('change', 'input[type="checkbox"]', function () {
        window.flafReloadSearch = true;
        setTimeout(function () {
            getAllData(true);
        }, 300)
    });
    $filters_search.on('blur', '.price_input input', function () {
        window.flafReloadSearch = true;
        setTimeout(function () {
            getAllData(true);
        }, 300)
    });

    $filters_search.on('click', '.price svg', function () {
        window.flafReloadSearch = true;
    });

    //Применить по overlay
    $('.overlay_page').on('click', function() {
        if(!window.flafReloadSearch) return true;

        if($filters_search.find('.filter_block').hasClass('open') && $(document).find('#xhr-filter-search').length) {
            $filters_search.find('#apply').trigger('click');
            $('.filter_block').removeClass('open');
        }
    });

    //Применить по кнопке
    $filters_search.on('click', '#apply', function () {
        if(!window.flafReloadSearch) return false;

        setTimeout(function () {
            getAllData();
        }, 300)
    });

    function getAllData(updateFilters) {
        updateFilters = updateFilters ? updateFilters : false;

        //Get checkbox
        var $selected = $filters_search.find('.filter_block input[type="checkbox"]:checked');
        var obj = {};
        obj['values'] = [];
        $selected.each(function () {
            obj['values'].push($(this).val());
        });

        //Get prices
        var priceFrom = Number($('#priceFrom').val());
        var priceTo = Number($('#priceTo').val());

        var priceParam = '';
        if(priceFrom !== Number($('#priceFrom').attr('data-min')) || priceTo !== Number($('#priceTo').attr('data-max'))) {
            priceParam = priceFrom + '-' + priceTo;
        }

        obj['prices'] = [];
        obj['price'] = priceParam;
        obj['update_filters'] = updateFilters;
        obj['page'] = 1;
        obj['start'] = 1;

        APP.search.setParams(obj);
    }


    //сбросить всё
    $filters_search.on('click', '#reset-all', function () {
        setTimeout(function () {
            $filters_search.find('.selected_filters > span').remove();
            $('#priceFrom').val($('#priceFrom').attr('data-min'));
            $('#priceTo').val($('#priceTo').attr('data-max'));
            $filters_search.find('input[type="checkbox"]').prop('checked', false);
            $('.catalog_filter .filter').attr('data-category', 'false');

            var obj = {};
            obj['values'] = [];
            obj['update_filters'] = false;
            obj['page'] = 1;
            obj['start'] = 1;
            obj['categories'] = [];
            obj['price'] = '';

            APP.search.setParams(obj);
        }, 200);
    });

});


APP('suggest', function () {
    this.autocomplete = function (data) {
        return APP.core.promise(function (resolve, reject) {
            var req = APP.ajax.get(APP.global.route.suggest, data);
            req.done(function (resp) {
                if (resp.found) {
                    resolve(resp)
                } else {
                    reject()
                }
            });
            req.fail(function () {
                reject();
            });
        });
    }
});

$(function () {
    var $form = $('form.search'),
        $searchRes = $('.search_result');

    var autocomplete = APP.core.debounce(function(data) {
        APP.suggest.autocomplete(data).then(function(resp) {
            $('#search-result').html(resp.html);
            $searchRes.fadeIn(200);
        }, function() {
            $searchRes.fadeOut(200);
        })
    }, 400);

    $form.on('keyup', 'input[type=search]', function() {
        var $input = $(this);
        if ($input.val().length >= 2) {
            var data = $input.closest('form').serialize();
            autocomplete(data);
        } else {
            $searchRes.fadeOut(200);
        }
    });

    $(document).mouseup(function (e) {
        if ($form.has(e.target).length === 0){
            //$form.removeClass('open');
        }
    });

});
